import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import MediaQueries from '../../tokens/MediaQueries';
import Colours from '../../tokens/colours';
const getStyles = createUseStyles({
    hover: {
        extend: 'itemActive',
        backgroundColor: Colours.septernary,
    },
    root: {
        textAlign: 'center',
        position: 'relative',
        borderRadius: 4,
        paddingTop: 8,
        paddingBottom: 8,
        cursor: 'pointer',
        [MediaQueries.medium]: {
            height: 40,
        },
        [MediaQueries.large]: {
            textAlign: 'left',
            transition: 'all 0.3s',
        },
    },
    link: {
        display: 'block',
        [MediaQueries.medium]: {
            width: 40,
        },
    },
    expandedLink: {
        [MediaQueries.large]: {
            width: '16rem',
        },
    },
    button: {
        width: '100%',
        [MediaQueries.medium]: {
            width: 40,
            boxSizing: 'border-box',
        },
    },
    expandedButton: {
        [MediaQueries.large]: {
            width: '16rem',
        },
    },
    selected: {
        backgroundColor: Colours.quarternary,
    },
    disabled: {
        cursor: 'default',
    },
});
const ClickableElement = ({ className, to, selected = false, disabled = false, children, onClick, isExpanded, }) => {
    const styles = getStyles();
    const [isHover, setIsHover] = useState(false);
    const isLink = to && !disabled;
    const isEternalLink = isLink && to.includes('http');
    const classes = classNames(styles.root, { [styles.link]: isLink }, { [styles.button]: !isLink }, { [styles.selected]: selected }, { [styles.hover]: isHover }, { [styles.disabled]: disabled }, { [styles.expandedLink]: isLink && isExpanded }, { [styles.expandedButton]: !isLink && isExpanded }, className);
    const onMouseEnter = () => {
        if (!disabled && !selected) {
            setIsHover(true);
        }
    };
    const onMouseLeave = () => {
        setIsHover(false);
    };
    if (isEternalLink) {
        return (React.createElement("a", { className: classes, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, target: "_blank", href: to }, children));
    }
    if (isLink) {
        return (React.createElement(Link, { className: classes, to: to, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick }, children));
    }
    return (React.createElement("button", { className: classes, disabled: disabled, type: "button", onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children));
};
export default ClickableElement;
//# sourceMappingURL=ClickableElement.js.map